// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbb_a bhb_g"};